import React from "react";
import "./Team.css";
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";
import CoreTeam from "../../Components/TeamPage/CoreTeam";
import WallOfFame from "../../Components/TeamPage/WallOfFame";
import AppTeam from "../../Components/TeamPage/AppTeam";
import WebTeam from "../../Components/TeamPage/WebTeam";
import ManagementTeam from "../../Components/TeamPage/Management";
import MlTeam from "../../Components/TeamPage/Ml";
import GraphicsTeam from "../../Components/TeamPage/Graphics";
import CCodingTeam from "../../Components/TeamPage/CCoding";
import CyberTeam from "../../Components/TeamPage/CyberSecurity";

function Team(){
  const[info,setInfo]=React.useState([]);

  React.useEffect(()=>{
    async function FetchData()
    {
      try{
        const url="https://sheets.googleapis.com/v4/spreadsheets/158UVlY_oswJSCLbjl2uQu2qEKi9greNvYO5kveXvRiQ/values:batchGet?ranges=A2:U1000&key=AIzaSyATGC19rqvjo4HJs8uMHFoittxEeoNViPs";
        const res=await fetch(url);
        const result=await res.json();
        const data=result.valueRanges[0].values;
        setInfo(data);
    }
    catch(err)
    {
      console.log(err);
    }
    }
    FetchData();
  },[]);

    return(
      <div>
      <Navbar/>
        <div className="team">
            <div className="header">
              <div className="heading">OUR TEAM</div>
            </div>
            <WallOfFame info={info}/>
            <CoreTeam info={info}/>
            <ManagementTeam info={info}/>
            <WebTeam info={info}/>
            <AppTeam info={info}/>
            <GraphicsTeam info={info}/>
            <MlTeam info={info}/>
            <CCodingTeam info={info}/>
            <CyberTeam info={info}/>
        </div>   
        <Footer/>
      </div>
    );
}
export default Team;
